export const environment = {
  production: true,
  environmentName: 'UAT',
  apiUrl: 'https://provart-uat-k8s.conexia.com.ar/provart-ml-back/', // it could be an object with different urls
  defaultDayOfBirth: '1920-01-01'
};
